import { faCircleNotch, faDownload, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { translate } from "../../../intl";
import { FileUploadProps } from "../fileUploadTypes";

interface FileAttachListItemProps {
  file: FileUploadProps;
  index: number;
  downloadingId: number;
  handleDownload: (file: FileUploadProps) => void;
  handleDelete: (fileId: number, index: number) => void;
  getFileIcon: (fileName: string, hasError: boolean) => React.ReactNode;
  maxFileSize: number;
}

const FileAttachListItem: React.FC<FileAttachListItemProps> = ({
  file,
  index,
  downloadingId,
  handleDownload,
  handleDelete,
  getFileIcon,
  maxFileSize,
}) => {
  const hasError =
    file?.status === "error" || file?.status === "unsupported" || file?.status === "size-exceeded";
  return (
    <div
      className={`file-attach__list-item${hasError ? " file-attach__list-item--error" : ""}`}
      aria-invalid={hasError}
      data-index={index}
    >
      {getFileIcon(file.file_name, hasError)}
      <span className="file-attach__name">{file.file_name}</span>
      <span className={hasError ? "file-attach__status-error" : "file-attach__status"}>
        {file.status === "uploading" && (
          <FontAwesomeIcon icon={faCircleNotch} spin className="file-attach__status-icon" />
        )}
        {file.status === "uploading" && translate("genericComponents.file.uploading")}
        {file.status === "completed" && translate("genericComponents.file.completed")}
        {file.status === "error" && file.error}
        {file.status === "unsupported" && translate("genericComponents.file.error.unsupported")}
        {file.status === "size-exceeded" &&
          translate("genericComponents.file.error.sizeExceeded", { maxFileSize })}
      </span>
      <FontAwesomeIcon
        icon={downloadingId === file.attachment_id ? faCircleNotch : faDownload}
        spin={downloadingId === file.attachment_id}
        className="file-attach__action"
        title="Download"
        onClick={() => handleDownload(file)}
      />
      <FontAwesomeIcon
        icon={faTimes}
        className="file-attach__action"
        onClick={() => handleDelete(file.attachment_id, index)}
        title="Remove"
      />
    </div>
  );
};

export default FileAttachListItem;
